import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { fulfillmentEventsAdminRouter } from './routing/fulfillmentEventsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  fulfillmentEventsModifyAccessControl,
  fulfillmentEventsViewAccessControl,
} from './access-control/fulfillmentEventsAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-events',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'fulfillment-events-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    admin: [fulfillmentEventsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.MarketplaceOps,
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-fulfillment-events-list',
          labelId: 'fulfillmentEventsDomain.manageEvents',
          accessControl: fulfillmentEventsViewAccessControl,
        },
      ],
    },
    {
      attachTo: AdminNavEntryPoint.MarketplaceOps,
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-fulfillment-events-approval-requests-list',
          labelId: 'fulfillmentEventsDomain.manageEventsApprovalRequests',
          accessControl: fulfillmentEventsModifyAccessControl,
        },
      ],
    },
  ],
}

export default definition
